import { globalGraphqlRequest } from 'core/utils/backend-service';
import { Location } from 'core/contexts/locations/location.model';
import * as API from './location.api';
import { mapLocationFromApiToVm } from './locations.api.mapper';
import { getAllLocations } from './locations.queries';

export const getLocations = async (): Promise<Location[]> =>
    globalGraphqlRequest(getAllLocations()).then((result) =>
        (result.data.locations as API.Location[]).map(mapLocationFromApiToVm)
    );
